const HTML_BLOCK_TAG_SET = new Set([
  'P',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'UL',
  'OL',
  'BLOCKQUOTE',
  'PRE',
  'TABLE',
  'FIGURE',
  'HR',
  'IMG',
])

const HTML_WRAPPER_TAG_SET = new Set([
  'BODY',
  'DIV',
  'SECTION',
  'ARTICLE',
  'MAIN',
  'HEADER',
  'FOOTER',
  'ASIDE',
  'NAV',
])

const HTML_SKIP_SILENT_TAG_SET = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE'])

export interface ShadowBlockEntry {
  index: number
  textContent: string
}

const normalizeWhitespace = (text: string): string => text.replace(/\s+/g, ' ').trim()

const hasVisibleText = (node: HTMLElement): boolean => (node.textContent ?? '').trim().length > 0

const stampLeaf = (node: HTMLElement, entries: ShadowBlockEntry[]): void => {
  const index = entries.length
  node.setAttribute('data-block-id', String(index))
  entries.push({ index, textContent: normalizeWhitespace(node.textContent ?? '') })
}

const stampNode = (node: ChildNode, entries: ShadowBlockEntry[]): void => {
  if (!(node instanceof HTMLElement)) return
  if (HTML_SKIP_SILENT_TAG_SET.has(node.tagName)) return

  if (HTML_BLOCK_TAG_SET.has(node.tagName)) {
    stampLeaf(node, entries)
    return
  }

  if (HTML_WRAPPER_TAG_SET.has(node.tagName)) {
    const sizeBefore = entries.length
    node.childNodes.forEach((child) => {
      stampNode(child, entries)
    })
    if (entries.length === sizeBefore && hasVisibleText(node)) {
      stampLeaf(node, entries)
    }
    return
  }

  if (hasVisibleText(node)) {
    stampLeaf(node, entries)
  }
}

export const stampShadowBlocks = (root: ParentNode): ShadowBlockEntry[] => {
  const entries: ShadowBlockEntry[] = []
  root.childNodes.forEach((child) => {
    stampNode(child, entries)
  })
  return entries
}
